var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHistory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2055_3670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.72745 15.4226C6.0527 16.4295 6.5648 17.2201 7.15129 17.9657C9.65988 21.1542 14.1805 22.3082 17.9296 20.7269C22.0489 18.9882 24.3239 14.6215 23.3983 10.2306C22.4174 5.57505 17.9936 2.43152 13.274 2.99899C11.1166 3.25849 9.30349 4.16678 7.78277 5.69788C7.46616 6.01621 7.15302 6.3553 6.6565 6.32762C6.22225 6.30167 5.88835 6.06811 5.71707 5.66847C5.53888 5.2498 5.62711 4.85188 5.93506 4.51106C7.32603 2.97303 9.0163 1.90213 10.9938 1.28449C16.6839 -0.492279 22.836 2.45402 25.0211 8.00232C27.2217 13.5852 24.7183 19.9155 19.2963 22.4847C13.1425 25.3998 5.88143 22.367 3.641 15.9295C3.50432 15.5385 3.33478 15.3845 2.91956 15.4139C2.39016 15.452 1.85731 15.4208 1.32445 15.4243C0.85906 15.426 0.530349 15.2132 0.326201 14.8015C0.132434 14.4105 0.187796 14.0368 0.455956 13.7133C1.39019 12.5835 2.3175 11.4486 3.28461 10.35C3.73961 9.83273 4.46797 9.92961 4.97315 10.523C5.76378 11.4538 6.54231 12.3949 7.3243 13.3326C7.44367 13.4762 7.56824 13.6181 7.66858 13.7738C8.10975 14.4676 7.64955 15.3689 6.82604 15.4174C6.48522 15.4364 6.14094 15.4208 5.72572 15.4208L5.72745 15.4226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4418 12.1908C16.4055 12.1908 17.2965 12.1631 18.1822 12.2064C18.5023 12.2219 18.8795 12.3327 19.1165 12.5351C19.7237 13.0524 19.4902 14.0074 18.7307 14.2565C18.5438 14.317 18.3379 14.3447 18.1407 14.3447C16.9643 14.3534 15.7878 14.3516 14.6097 14.3482C13.7048 14.3447 13.2844 13.9382 13.2827 13.0385C13.2758 10.9296 13.2862 8.81891 13.2827 6.70997C13.2827 6.18922 13.4574 5.774 13.9453 5.55775C14.3277 5.38993 14.7048 5.45221 15.0353 5.7221C15.3813 6.0041 15.4453 6.38991 15.4436 6.80512C15.4401 8.41235 15.4436 10.0196 15.4436 11.6268C15.4436 11.7963 15.4436 11.9659 15.4436 12.1925L15.4418 12.1908Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2055_3670",
    x: 0.210938,
    y: 0.768097,
    width: 25.6067,
    height: 23.8288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2055_3670"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2055_3670",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon-history.4df9cf75156bee68cfdd5d07c0ab9126.svg";
export { ForwardRef as ReactComponent };